export const ApiGetSpaces = Symbol('ApiGetSpaces');
